import React, { createContext, useContext, useMemo } from 'react';
import { mockSlackClient } from "../utils/slack-client";
import { useStateInRef } from 'seagull';

function throwUnsetContextError(f) {
  return () => {
    throw new Error("Somebody is trying to use ".concat(f, " without a properly set context"));
  };
}

export const mockIntercom = () => {};
export const mockHotjar = {
  identify() {}

};
export const mockOpenNewTab = () => null;
export const MockYoutubePlayer = () => /*#__PURE__*/React.createElement(React.Fragment, null);
const Context = /*#__PURE__*/createContext({
  slackClient: mockSlackClient,
  getNow: throwUnsetContextError('getNow'),
  usePlaidLink: throwUnsetContextError('usePlaidLink'),
  locationReload: throwUnsetContextError('locationReload'),
  copyToClipboard: throwUnsetContextError('copyToClipboard'),
  getIntercom: () => mockIntercom,
  getHotjar: () => mockHotjar,
  openNewTab: mockOpenNewTab,
  personaClient: throwUnsetContextError('personaClient'),
  YoutubePlayer: MockYoutubePlayer
});
export function IoContextProvider(props) {
  const getStateInRef = useStateInRef(props);
  const value = useMemo(() => {
    const {
      slackClient,
      getNow,
      usePlaidLink,
      locationReload,
      copyToClipboard,
      getIntercom,
      getHotjar,
      openNewTab,
      personaClient,
      YoutubePlayer
    } = getStateInRef();
    return {
      slackClient,
      getNow,
      usePlaidLink,
      locationReload,
      copyToClipboard,
      getIntercom,
      getHotjar,
      openNewTab,
      personaClient,
      YoutubePlayer
    };
  }, []);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, props.children);
}
export const useIoContext = () => useContext(Context);
export default IoContextProvider;